import React from "react";
import dayjs from "dayjs";

import { isNullOrUndefined } from "../../HWLibrary/HWUtils";
import { s360ConfigService } from "../../Services/S360Config";

import { MessageType } from "./Message";

function TextMessage(props) {
  const isLink = (string) => {
    return !!(
      (!isNullOrUndefined(string) && string?.includes("https://")) ||
      string?.includes("http://")
    );
  };
  const extractLinkFunction = (message) => {
    if (message.includes("href")) {
      message.match(/\bhttps?:\/\/\S+/gi);
      if (
        message.match(/"([^"]*)"/)[0].length >= 2 &&
        message.match(/"([^"]*)"/)[0].charAt(0) == '"' &&
        message
          .match(/"([^"]*)"/)[0]
          .charAt(message.match(/"([^"]*)"/)[0].length - 1) == '"'
      ) {
        message = message
          .match(/"([^"]*)"/)[0]
          .substring(1, message.match(/"([^"]*)"/)[0].length - 1);
      }

      return message;
    } else return message;
  };

  const showMessageTime = () => {
    return props.message.type !== MessageType.info;
  };

  const messageTimeClassName = () => {
    switch (props.message.type) {
      case MessageType.sent:
        return "s360-message-time-sent";
      case MessageType.received:
        return "s360-message-time-received";
      case MessageType.info:
        return "s360-message-time-info";
      default:
        return "";
    }
  };

  const messageBoxClassName = () => {
    switch (props.message.type) {
      case MessageType.sent:
        return "s360-message-box-sent";
      case MessageType.received:
        return "s360-message-box-received";
      case MessageType.info:
        return props.convoType === "TRANSFER"
          ? "s360-message-box-info-agent"
          : "s360-message-box-info";
      default:
        return "";
    }
  };

  const messageContainerClassName = () => {
    switch (props.message.type) {
      case MessageType.sent:
        return "s360-message-cotainer-sent";
      case MessageType.received:
        return s360ConfigService.config.autoFullScreen
          ? "s360-message-cotainer-received-fs"
          : "s360-message-cotainer-received";
      case MessageType.info:
        return "s360-message-cotainer-info";
      default:
        return "";
    }
  };

  const messageBoxStyle = () => {
    let config = props.config;
    switch (props.message.type) {
      case MessageType.sent:
        return config?.customDesign?.textMessageBoxSender;
      case MessageType.received:
        return config?.customDesign?.textMessageBoxReceiver;
      case MessageType.info:
        return config?.customDesign?.textMessageBoxInfo;
      default:
        return {};
    }
  };

  const messageTimeStyle = () => {
    let config = props.config;
    switch (props.message.type) {
      case MessageType.received:
      case MessageType.sent:
      case MessageType.info:
        return config?.customDesign?.textMessageTime;
      default:
        return {};
    }
  };

  const text = props?.message?.message?.text;
  text?.replace(/\n/g, "<br/>");

  return (
    <div className={messageContainerClassName()}>
      {isLink(props?.message?.message?.text) ? (
        <div className={messageBoxClassName()} style={messageBoxStyle()}>
          <a
            
            target="_blank"
            rel="noreferrer"
            href={extractLinkFunction(props?.message?.message?.text)}
          >
            {props?.message?.message?.text}
          </a>
          <br />
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "end",
            justifyContent: "center",
          }}
        >
          <div
            className={messageBoxClassName()}
            style={messageBoxStyle()}
            dangerouslySetInnerHTML={{ __html: text?.replace(/\n/g, "<br/>") }}
          ></div>
        </div>
      )}
      <div style={{ display: "flex", alignItems: "center", marginRight: 7 }}>
        {showMessageTime() && (
          <div className={messageTimeClassName()} style={messageTimeStyle()}>
            {dayjs
              .unix(Math.trunc(props?.message?.message?.sentTimestamp / 1000))
              .format("DD MMM h:mm a")}
          </div>
        )}
      </div>
    </div>
  );
}

export default TextMessage;
